<template>
  <div v-if="locale !== 'ja'" class="bg-gray-50 border-t border-gray-200 py-12">
    <div class="max-w-[1400px] mx-auto px-6">
      <h2 class="text-2xl font-bold text-gray-900 mb-8">{{ t('sections.exploreMore') }}</h2>
      <div class="">
        <div>
          <h3 class="text-lg font-semibold text-gray-900 mb-4">{{ t('sections.latestVideos') }}</h3>
          <div :class="cls">
            <VideoCard v-for="video in pageContext.data.videos" :key="video.id" v-bind="video" />
          </div>
        </div>
        <!-- TODO -->
        <div v-if="false">
          <h3 class="text-lg font-semibold text-gray-900 mb-4">{{ t('sections.latestArticles') }}</h3>
          <div :class="cls">
            <ArticleCard v-for="article in articles" :key="article.id" v-bind="article" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n';
import { cva, type VariantProps } from 'class-variance-authority'
import { usePageContext } from "vike-vue/usePageContext";
import VideoCard from './VideoCard.vue';
import ArticleCard from './ArticleCard.vue';

const { t, locale } = useI18n();
const pageContext = usePageContext()
const articles = [
  { id: 1, image: 'https://images.unsplash.com/photo-1663756915301-2ba688e078cf?auto=format&fit=crop&q=80', title: 'Property Taxes in Japan', excerpt: 'Learn about taxes.', readTime: '6 min', date: 'Dec 19, 2025', category: 'Guide' }
];

const grid = cva('grid gap-4', {
  variants: {
    base: {
      1: 'grid-cols-1',
      2: 'grid-cols-2',
      3: 'grid-cols-3',
      4: 'grid-cols-4',
      5: 'grid-cols-5',
      6: 'grid-cols-6'
    },
    sm: {
      1: 'sm:grid-cols-1',
      2: 'sm:grid-cols-2',
      3: 'sm:grid-cols-3',
      4: 'sm:grid-cols-4',
      5: 'sm:grid-cols-5',
      6: 'sm:grid-cols-6'
    },
    md: {
      1: 'md:grid-cols-1',
      2: 'md:grid-cols-2',
      3: 'md:grid-cols-3',
      4: 'md:grid-cols-4',
      5: 'md:grid-cols-5',
      6: 'md:grid-cols-6'
    },
    lg: {
      1: 'lg:grid-cols-1',
      2: 'lg:grid-cols-2',
      3: 'lg:grid-cols-3',
      4: 'lg:grid-cols-4',
      5: 'lg:grid-cols-5',
      6: 'lg:grid-cols-6'
    }
  },
  defaultVariants: {
    base: 1,
    sm: 2,
    md: 4,
    lg: 4
  }
})

type GridVariants = VariantProps<typeof grid>
type Options = '1' | '2' | '3' | '4' | '5' | '6'
const props = defineProps<{
  base?: Options
  sm?: Options
  md?: Options
  lg?: Options
}>()

const cls = computed(() => grid(props))
</script>
